import { addBookparts } from '../api/bookparts';

import { socket, getSocketConnectionData as wsConnection } from '@speechki-frontend/core/socket';

import { getToken } from '@speechki-frontend/core/auth/utils';

const defaultParams = {
    interval: 5000
};
const ERROR_MESSAGE = [
    {
        detail: 'Generation error, please try again'
    }
];

export const addSentence = async (book, data, params = defaultParams) => {
    const { extra_data } = await addBookparts(book, data);
    const newIds = extra_data.new_book_part_ids
        .slice()
        .filter((elem, index) => (index + 1) % 2 === 0)
        .sort()
        .join(',');

    let promiseResolve, promiseReject, pollInterval;
    window.onbeforeunload = () => {
        clearInterval(pollInterval);
    };

    const client = socket(wsConnection(getToken()));

    client.receiver.on('record_process_book_part_update', handleMessage);

    const off = () => {
        client.receiver.off('record_process_book_part_update', handleMessage);
    };

    async function handleMessage({ code, params = {} }) {
        clearInterval(pollInterval);
        pollInterval = null;

        if (params.action === 'generate' && code === 200) {
            const ids = params.extra_data.bp_ids.sort().join(',');

            if (ids === newIds && params.is_completed) {
                off();
                return promiseResolve();
            }

            return;
        }

        return promiseReject(ERROR_MESSAGE);
    }

    const promise = new Promise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;
    });

    return promise;
};
